(function(){
var $=function(s,r){return(r||document).querySelector(s)},$$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
var strip=function(t){return String(t==null?'':t).replace(/<[^>]*>/g,'')};
var cart=$('#cart-drawer'),busy=false;
function swapCart(html){
  var d=new DOMParser().parseFromString(html,'text/html').querySelector('[id^=shopify-section]');
  var w=cart.querySelector('[id^=shopify-section]');
  if(d&&w){w.innerHTML=d.innerHTML}
  var c=cart.querySelector('[data-count]');var n=c?+c.getAttribute('data-count'):0;
  $$('[data-cart-count]').forEach(function(e){e.textContent=n;e.hidden=!n});
}
function refresh(){
  return fetch('/?sections=era-cart-drawer',{cache:'no-store',headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(j){swapCart(j['era-cart-drawer'])});
}
function openCart(){if(cart&&!cart.open)cart.showModal()}
function changeLine(line,qty){
  if(busy)return;busy=true;var c=cart.querySelector('.cd');if(c)c.classList.add('is-busy');
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:+line,quantity:+qty})})
    .then(refresh).catch(function(){}).then(function(){busy=false});
}
function closeNav(){$$('.nrow li.is-open').forEach(function(l){l.classList.remove('is-open');var b=l.querySelector('[data-nsub]');if(b)b.setAttribute('aria-expanded','false')})}
document.addEventListener('click',function(e){
  var t=e.target,nt=t.closest('[data-nsub]');
  if(nt){
    var li=nt.parentNode,sub=li.querySelector('.sub'),was=li.classList.contains('is-open');
    closeNav();
    if(!was){li.classList.add('is-open');nt.setAttribute('aria-expanded','true');if(innerWidth<990&&sub){sub.style.top=nt.closest('.nrow').getBoundingClientRect().bottom+'px'}}
    return;
  }
  if(!t.closest('.nrow'))closeNav();
  var o=t.closest('[data-open]');
  if(o){var d=document.getElementById(o.getAttribute('data-open'));if(d){d.showModal();var i=$('input[type=search]',d);if(i)i.focus()}return}
  var c=t.closest('[data-close]');if(c){c.closest('dialog').close();return}
  if(t.tagName==='DIALOG'){t.close();return}
  var q=t.closest('[data-line]');if(q){changeLine(q.getAttribute('data-line'),q.getAttribute('data-qty'));return}
  var st=t.closest('[data-q]');
  if(st){var inp=st.parentNode.querySelector('input'),v=Math.max(1,(+inp.value||1)+ +st.getAttribute('data-q'));inp.value=Math.min(v,+inp.max||99);return}
  var sh=t.closest('[data-share]');
  if(sh){
    var u=sh.getAttribute('data-url'),ti=sh.getAttribute('data-title');
    if(navigator.share){navigator.share({title:ti,url:u}).catch(function(){})}
    else if(navigator.clipboard){navigator.clipboard.writeText(u).then(function(){var sp=sh.querySelector('span'),old=sp.textContent;sp.textContent=sh.getAttribute('data-copied')||'Copied';setTimeout(function(){sp.textContent=old},1600)})}
  }
});
document.addEventListener('keydown',function(e){if(e.key==='Escape')closeNav()});
window.addEventListener('scroll',closeNav,{passive:true});
$$('[data-nscroll]').forEach(function(w){
  var n=$('.nrow',w);
  function u(){w.classList.toggle('is-end',n.scrollLeft+n.clientWidth>=n.scrollWidth-4);w.classList.toggle('is-start',n.scrollLeft<=4)}
  n.addEventListener('scroll',function(){u();closeNav()},{passive:true});window.addEventListener('resize',u);u();
});
document.addEventListener('submit',function(e){
  var f=e.target;if(!f.matches||!f.matches('form[data-atc]'))return;
  if(e.submitter&&e.submitter.name==='checkout')return;
  e.preventDefault();
  if(f.getAttribute('data-busy'))return;
  f.setAttribute('data-busy','1');
  var b=$('button[type=submit]',f),l=$('.lbl',f),msg=$('.msg',f),old=l?l.textContent:'';
  b.classList.add('is-load');b.setAttribute('aria-busy','true');if(msg)msg.textContent='';
  fetch('/cart/add.js',{method:'POST',body:new FormData(f),headers:{Accept:'application/json'}})
    .then(function(r){return r.json().then(function(d){if(!r.ok||d.status){throw new Error(d.description||d.message||'Could not add this item.')}return d})})
    .then(function(){return refresh()}).then(function(){
      b.classList.remove('is-load');if(l)l.textContent='Added';openCart();
      setTimeout(function(){if(l)l.textContent=old},1400);
    })
    .catch(function(err){b.classList.remove('is-load');if(msg)msg.textContent=err.message})
    .then(function(){b.removeAttribute('aria-busy');f.removeAttribute('data-busy')});
});
document.addEventListener('change',function(e){
  var s=e.target.closest&&e.target.closest('[data-sort]');
  if(s){var u=new URL(location.href);u.searchParams.set('sort_by',s.value);u.searchParams.delete('page');location.href=u.toString()}
});
var si=$('#search-dialog input[type=search]'),out=$('#predictive'),tm,ctl;
if(si&&out){si.addEventListener('input',function(){
  clearTimeout(tm);var q=si.value.trim();if(q.length<2){out.innerHTML='';return}
  tm=setTimeout(function(){
    if(ctl)ctl.abort();ctl=new AbortController();
    fetch('/search/suggest?q='+encodeURIComponent(q)+'&resources[type]=product,collection&resources[limit]=6&section_id=era-predictive',{signal:ctl.signal})
      .then(function(r){return r.text()}).then(function(h){var d=new DOMParser().parseFromString(h,'text/html').querySelector('[id^=shopify-section]');out.innerHTML=d?d.innerHTML:''}).catch(function(){});
  },200)})}
var pj=$('#pv-json');
if(pj){
  var V=JSON.parse(pj.textContent),f=$('#product-form'),idIn=$('[name=id]',f),pr=$('#pv-price'),cp=$('#pv-compare'),add=$('#pv-add'),lb=$('.lbl',add),subs=$$('button[type=submit]',f),sv=$('#pv-save'),stk=$('#pv-stock'),av=$('#pv-avail');
  var tAdd=add.getAttribute('data-add')||'Add to cart',tSold=add.getAttribute('data-sold')||'Sold out';
  f.addEventListener('change',function(e){
    if(!e.target.classList.contains('opt'))return;
    var sel=$$('.opt:checked',f).map(function(i){return i.value});
    var v=V.filter(function(x){return x.o.every(function(o,i){return o===sel[i]})})[0];
    if(!v){lb.textContent='Unavailable';subs.forEach(function(b){b.disabled=true});return}
    idIn.value=v.id;pr.textContent=strip(v.p);cp.textContent=strip(v.c);pr.classList.toggle('is-sale',!!v.c);
    if(sv)sv.textContent=strip(v.s);
    if(stk){var mx=+stk.getAttribute('data-max');if(v.q>0&&v.q<=mx){stk.hidden=false;stk.textContent=stk.getAttribute('data-t').replace('[q]',v.q)}else{stk.hidden=true}}
    if(av){av.textContent=v.a?av.getAttribute('data-in'):av.getAttribute('data-out');av.className=v.a?'in':'out'}
    subs.forEach(function(b){b.disabled=!v.a});lb.textContent=v.a?tAdd:tSold;
    history.replaceState(null,'','?variant='+v.id);
    var s=v.m&&document.getElementById('m-'+v.m);
    if(s){var g=s.parentNode;if(g.scrollWidth>g.clientWidth){g.scrollTo({left:s.offsetLeft-g.offsetLeft,behavior:'smooth'})}else{s.scrollIntoView({behavior:'smooth',block:'nearest'})}}
  });
}
var rl=$('[data-rec]');
if(rl&&'IntersectionObserver' in window){new IntersectionObserver(function(en,ob){
  if(en[0].isIntersecting){ob.disconnect();fetch(rl.getAttribute('data-rec')).then(function(r){return r.text()}).then(function(h){var d=new DOMParser().parseFromString(h,'text/html').querySelector('[id^=shopify-section]');if(d&&d.querySelector('.pc'))rl.innerHTML=d.innerHTML}).catch(function(){})}
},{rootMargin:'400px'}).observe(rl)}
})();